module.exports = __webpack_public_path__ + "img/azul.9d464ded.svg";